import React from 'react';
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

// --- Configuration de la vidéo de bienvenue ---
const VIDEO_ASPECT_RATIO = '9:16';
const WELCOME_VIDEO_URL = 'https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2Freel%2F1941510943215055&show_text=false';

const WelcomeGuideDialog = ({ open, onClose }) => {
  const { t } = useTranslation();

  const handleContinue = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { borderRadius: 3, maxHeight: '95vh', display: 'flex', flexDirection: 'column' } }}
    >
      <DialogTitle
        sx={{
          textAlign: 'center',
          pt: 2.5,
          pb: 2,
          mb: '4px',
          flexShrink: 0,
          background: 'linear-gradient(45deg, #6200ee 30%, #03dac4 90%)',
          color: 'white',
          boxShadow: '0 4px 15px rgba(98, 0, 238, 0.3)',
        }}
      >
        <Typography variant="h4" fontWeight={700} sx={{ color: 'white' }}>
          {t('welcome.title', 'Bienvenue sur Krillou !')}
        </Typography>
        <Typography variant="body1" sx={{ mt: 1, color: 'white', opacity: 0.95 }}>
          {t('welcome.subtitle', 'Découvrez en quelques minutes comment créer votre premier listing ou produit.')}
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ flex: 1, overflow: 'hidden', display: 'flex', justifyContent: 'center', alignItems: 'center', px: 2, py: 1 }}>
        <Box
          sx={{
            height: '60vh',
            aspectRatio: VIDEO_ASPECT_RATIO.replace(':', ' / '),
            maxWidth: '100%',
            borderRadius: 2,
            overflow: 'hidden',
            bgcolor: 'grey.900',
          }}
        >
          <iframe
            src={WELCOME_VIDEO_URL}
            title="Guide Krillou"
            scrolling="no"
            frameBorder="0"
            style={{
              width: '100%',
              height: '100%',
              border: 0,
              borderRadius: 8,
              display: 'block',
            }}
            allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
            allowFullScreen
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: { xs: 2, sm: 4 }, pb: 2, flexDirection: 'column', gap: 1 }}>
        <Button
          variant="contained"
          fullWidth
          size="large"
          onClick={handleContinue}
          sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 700 }}
        >
          {t('welcome.continue', 'Continuer vers mon tableau de bord')}
        </Button>
        <Button
          variant="text"
          size="small"
          onClick={handleContinue}
          sx={{ textTransform: 'none', color: 'text.secondary' }}
        >
          {t('welcome.skip', 'Passer cette étape')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default WelcomeGuideDialog;
